import { Box, Paragraph } from '@customerio/pluma-components/react';
import * as styles from './index.css';

type BrandLoaderProps = {
  label?: string;
  /**
   * Render inside a host that already owns viewport height and background
   * (the signup shell). Standalone is the default: the loader is the page.
   */
  isEmbedded?: boolean;
};

export function BrandLoader({ label, isEmbedded = false }: BrandLoaderProps) {
  return (
    <Box className={isEmbedded ? styles.screenEmbedded : styles.screenStandalone} role="status" aria-live="polite">
      <Box className={styles.stage}>
        <Box className={styles.bloomPrimary} aria-hidden="true" />
        <Box className={styles.bloomSecondary} aria-hidden="true" />
        <svg
          className={styles.mark}
          width="96"
          height="96"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            className={styles.markSegment}
            d="M26.7922 6.81435L20.0935 0.115646H13.3948V6.81435L20.0935 13.5105L13.3948 20.2092V26.9079H20.0935L26.7922 20.2092V6.81435Z"
          />
          <path
            className={`${styles.markSegment} ${styles.markSegmentDelay1}`}
            d="M6.6987 13.5105L13.3948 6.81437L10.0468 3.46373L6.6987 0.115669H0V6.81437L3.34806 10.1624L6.6987 13.5105Z"
          />
          <path
            className={`${styles.markSegment} ${styles.markSegmentDelay2}`}
            d="M3.34806 16.8611L0 20.2092V26.9079H6.6987L10.0468 23.5573L13.3948 20.2092L6.6987 13.5105L3.34806 16.8611Z"
          />
        </svg>
      </Box>
      {label == null ? (
        // Everything else here is aria-hidden, so without this the live region
        // announces nothing and the loading state is silent.
        <Box visuallyHidden={true}>Loading…</Box>
      ) : (
        <Paragraph variant="secondary" color="base">
          {label}
        </Paragraph>
      )}
    </Box>
  );
}
